import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SelectFieldContent from '@wix/da-ds/pkg/Dropdown/select/SelectField/SelectFieldContent';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { getAspectRatio } from '../../../../redux/form/selectors';
import { changeAspectRatio } from '../../../../redux/form/actions';
import { ratios } from '../constants';
import PanelInputField from '../PanelInputField';
import LabelText from '../LabelText';
import s from './AspectRatioSelectField.scss';
const AspectRatioSelectField = ()=>{
    const { t } = useTranslation('dreamup');
    const dispatchChangeAspectRatio = useAction(changeAspectRatio);
    const aspectRatio = useSelector(getAspectRatio);
    return /*#__PURE__*/ React.createElement(PanelInputField, {
        rootTag: "label",
        htmlFor: "aspectRatio",
        label: /*#__PURE__*/ React.createElement(LabelText, null, t('dreamup.header.settingsPanel.aspectRatio.label')),
        input: /*#__PURE__*/ React.createElement(SelectFieldContent, {
            id: "prompt-aspect-ratio",
            name: "aspectRatio",
            onSelect: dispatchChangeAspectRatio,
            items: ratios.map((ratio)=>({
                    label: t(ratio.label),
                    complexLabel: /*#__PURE__*/ React.createElement("div", {
                        className: s['current-value-label']
                    }, /*#__PURE__*/ React.createElement("div", {
                        className: ratio.prefixClassName
                    }), /*#__PURE__*/ React.createElement("span", null, t(ratio.label))),
                    value: ratio.value
                })),
            value: aspectRatio,
            withBlankOption: false,
            allowComplexLabelOnSelected: true
        })
    });
};
AspectRatioSelectField.displayName = 'AspectRatioSelectField';
export default AspectRatioSelectField;

//# sourceMappingURL=AspectRatioSelectField.js.map